// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__2qmNg","pageContainer":"app_pageContainer__34hqH","page":"app_page__2-oMl"};